import ValueLineChart, { type ValuePoint } from './ValueLineChart';

interface DailyContractValueData {
    readonly date: string;
    readonly value: number;
    /** Extrapolated point (running month scaled to a full month). */
    readonly projected?: boolean;
}

interface DailyContractValueChartProps {
    readonly data: readonly DailyContractValueData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
}
function DailyContractValueChart({
    data,
    loading = false,
    referenceValue,
    currency,
}: DailyContractValueChartProps): JSX.Element {
    const chartData: ValuePoint[] = data.map(d => ({
        date: d.date,
        value: d.value ?? 0,
        projected: d.projected,
    }));
    return (
        <ValueLineChart
            data={chartData}
            loading={loading}
            referenceValue={referenceValue}
            seriesNameKey="statistics.charts.contractValue"
            seriesNameFallback="Contract Value"
            color="#1890ff"
            currency={currency}
        />
    );
}

export default DailyContractValueChart;
